import { HtmlComponent } from './../../html-component';
import { Map } from './../map';

// import html
import template from './map-button.hogan.html';

export class MapToggleButton extends HtmlComponent {
    private active: boolean = false;

    constructor(private enableCallback: any, private disableCallback: any, text: string, icon: string) {
        super(template, { text, icon });
        this.jqueryElement.click(this.toggle);
    }

    public toggle = () => {
        if (this.active) {
            this.disable();
        } else {
            this.enable();
        }
    }

    public disable = () => {
        this.disableCallback();
        this.jqueryElement.removeClass('active');
        this.jqueryElement.addClass('inactive');
        this.active = false;
    }

    public enable = () => {
        this.active = true;
        this.enableCallback();
        this.jqueryElement.addClass('active');
        this.jqueryElement.removeClass('inactive');
    }
}
